import { render, staticRenderFns } from "./CouponStats.vue?vue&type=template&id=53212c06&scoped=true&"
import script from "./CouponStats.vue?vue&type=script&lang=js&"
export * from "./CouponStats.vue?vue&type=script&lang=js&"
import style0 from "./CouponStats.vue?vue&type=style&index=0&id=53212c06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53212c06",
  null
  
)

export default component.exports